export interface FileOutputLog {
  id: number;
  location: string;
  pbmConnectionId: number;
  status: string;
  dateDeliveredToPBM: string | null;
  dateCreatedBySystem: string;
  uaid: string;
  description: string | null;
  pbmConnection: {
    id: number;
    pbmId: number;
    pbm: {
      id: number;
      pbmName: string;
    }
  };
}

export interface FileOutputLogFilter {
  status?: string;
  pbmName?: string;
  uaid?: string;
  dateCreatedBySystemStart?: string;
  dateCreatedBySystemEnd?: string;
  dateDeliveredToPBMStart?: string;
  dateDeliveredToPBMEnd?: string;
}

import apiClient from '../utils/apiClient';

export const downloadFileOutputLog = async (id: number): Promise<void> => {
  const { blob, headers } = await apiClient.downloadFile(`api/FileOutputLog/download/${id}`);
  
  // Get filename from Content-Disposition header or default to 'output.csv'
  const contentDisposition = headers.get('Content-Disposition');
  let filename = 'output.csv';
  if (contentDisposition) {
    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
  }
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const getFileOutputLogs = async (filter?: FileOutputLogFilter): Promise<FileOutputLog[]> => {
  let url = 'api/FileOutputLog';
  
  if (filter) {
    const params = new URLSearchParams();
    if (filter.status) params.append('status', filter.status);
    if (filter.pbmName) params.append('pbmName', filter.pbmName);
    if (filter.uaid) params.append('uaid', filter.uaid);
    if (filter.dateCreatedBySystemStart) params.append('dateCreatedBySystemStart', filter.dateCreatedBySystemStart);
    if (filter.dateCreatedBySystemEnd) params.append('dateCreatedBySystemEnd', filter.dateCreatedBySystemEnd);
    if (filter.dateDeliveredToPBMStart) params.append('dateDeliveredToPBMStart', filter.dateDeliveredToPBMStart);
    if (filter.dateDeliveredToPBMEnd) params.append('dateDeliveredToPBMEnd', filter.dateDeliveredToPBMEnd);
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
  }

  return apiClient.get<FileOutputLog[]>(url);
};
